
import { mapMutations, mapState } from 'vuex';
import Block from '@/components/ui/block.vue';
import WpImage from '~/components/ui/img.vue';
import Testimonial from '@/components/blocks/testimonial.vue';
import ContactForm from '@/components/contactForm.vue';

export default {
  name: 'TestimonialSingle',

  components: {
    Block,
    WpImage,
    Testimonial,
    ContactForm,
  },

  async fetch() {
    try {
      const slug = this.$route.params.slug;
      const { data } = await this.$wp.testimonials({ slug });
      if (data.length) {
        this.addTestimonial(data[0]);
      } else {
        return this.$nuxt.error({ statusCode: 404 });
      }
    } catch (_) {
      return this.$nuxt.error({ statusCode: 404 });
    }
  },

  data() {
    return {
      relatedTestimonials: null,
    };
  },

  computed: {
    ...mapState(['patientId', 'testimonials']),

    testimonial() {
      return this.testimonials.find((t) => t.slug === this.$route.params.slug);
    },
    content() {
      return this.testimonial ? this.testimonial.content.rendered : null;
    },
    blocks() {
      return this.testimonial ? this.testimonial.fields.blocks : [];
    },
    defaultBlock() {
      return this.testimonial.acf.default_blocks
        ? this.testimonial.acf.default_blocks[0]
        : null;
    },
  },

  async mounted() {
    const { data } = await this.$wp.testimonials({
      perPage: 5,
    });
    if (data) {
      this.relatedTestimonials = data;
    }
    this.$bolev.metaEvent({
      type: 'pageView',
      patientId: this.patientId,
    });
  },

  methods: {
    ...mapMutations(['addTestimonial']),
  },

  head() {
    if (this.testimonial) {
      return this.$seo.yoast(this.testimonial.yoast_head_json);
    }
  },
};
